import { request } from '../api';

// Every endpoint is scoped to the caller's own facility - the client comes from the session, so
// there is no id in any of these paths.

export const getDcsPublication = (action) => {
  return request(action, { payload: { url: `/dcs-publication`, options: { method: 'GET' } } });
};

export const getDcsDataPoints = (action) => {
  const ids = action.deviceIds?.toJS ? action.deviceIds.toJS() : (action.deviceIds || []);
  const query = ids.length ? `?deviceIds=${encodeURIComponent(ids.join(','))}` : '';
  return request(action, { payload: { url: `/dcs-publication/data-points${query}`, options: { method: 'GET' } } });
};

export const getDcsMap = (action) => {
  return request(action, { payload: { url: `/dcs-publication/map`, options: { method: 'GET' } } });
};

export const createDcsPublication = (action) => {
  return request(action, {
    payload: {
      url: `/dcs-publication`,
      options: { method: 'POST', data: action.publication?.toJS ? action.publication.toJS() : action.publication }
    }
  });
};

export const updateDcsPublication = (action) => {
  return request(action, {
    payload: {
      url: `/dcs-publication`,
      options: { method: 'PUT', data: action.publication?.toJS ? action.publication.toJS() : action.publication }
    }
  });
};

export const addDcsPoints = (action) => {
  return request(action, {
    payload: {
      url: `/dcs-publication/points`,
      options: {
        method: 'POST',
        data: {
          deviceIds: action.deviceIds?.toJS ? action.deviceIds.toJS() : action.deviceIds,
          dataPoints: action.dataPoints?.toJS ? action.dataPoints.toJS() : action.dataPoints
        }
      }
    }
  });
};

export const removeDcsPoint = (action) => {
  return request(action, {
    payload: { url: `/dcs-publication/points/${action.pointId}`, options: { method: 'DELETE' } }
  });
};

export const resetDcsPoints = (action) => {
  return request(action, {
    payload: { url: `/dcs-publication/points`, options: { method: 'DELETE' } }
  });
};

export const reassignDcsAddresses = (action) => {
  return request(action, {
    payload: {
      url: `/dcs-publication/points/addresses`,
      options: {
        method: 'PUT',
        data: { assignments: action.assignments?.toJS ? action.assignments.toJS() : action.assignments }
      }
    }
  });
};
